export default __webpack_public_path__ + "static/media/Erwin1.2cb091f8.jpeg";